import axios from "axios";

/**
 * Shared axios client. Always uses REACT_APP_BACKEND_URL from env.
 * Every consumer prefixes routes with `/api/...`.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const apiClient = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000,
});

// Bubble up server error messages when available so the UI can toast them.
apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (detail) err.userMessage = detail;
    return Promise.reject(err);
  },
);
